module.exports = __webpack_public_path__ + "media/src/components/HealthInsurancePage/DefinitionSection/health-insurance-1d4322af54cb400666c14627d0acd09d.png";